module.exports = __webpack_public_path__ + "images/emoji/wavy_dash.95552d0def2d937fe78c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/wavy_dash.png
// module id = ETUD
// module chunks = 2